import {Spinner, Message} from '../../index'
import {
    DynamicInputSelect,
} from '../../../utils/dynamicForm';

import AddSpacesToUser from './AddSpacesToUser';
export const FormUserSpaces = ({
                                     edit,
                                     formCleanHandler,
                                     isLoading,
                                     register,
                                     isError,
                                     isErrorUpdate,
                                     errors,
                                     isLoadingUpdate,
                                     isLoadingPost,
                                     handleSubmit,
                                     submitHandler,
                                     error,
                                     dataSpaces,
                                     dataUsers,
                                     setValue,
                                     watch,
                                     selectedSpaces,
                                     setSelectedSpaces
                                 }) => {

    // console.log(getDefaultCategoryOptions());
    // const categoryOptions = getDefaultCategoryOptions().map((option, index) => ({
    //   ...option,
    //   key: index.toString(),
    // }));

    // console.log('formuserSpaces');
    // console.log(dataSpaces);
    return (<div
            className='modal fade'
            id='userSpacesModal'
            data-bs-backdrop='static'
            data-bs-keyboard='false'
            tabIndex='-1'
            aria-labelledby='userSpaceModalLabel'
            aria-hidden='true'
        >
            <div className='modal-dialog'>
                <div className='modal-content modal-background'>
                    <div className='modal-header'>
                        <h3 className='modal-title ' id='userSpaceModalLabel'>
                            {edit ? 'Set/Edit Machines' : 'Add machines to a User'}
                        </h3>
                        <button
                            type='button'
                            className='btn-close'
                            data-bs-dismiss='modal'
                            aria-label='Close'
                            onClick={formCleanHandler}
                        ></button>
                    </div>
                    <div className='modal-body'>
                        {isLoading ? (<Spinner/>) : isError ? (
                            <Message variant='danger'>{error}</Message>) : isErrorUpdate ? (
                            <Message variant='danger'>{error}</Message>) : (
                            <form onSubmit={handleSubmit(submitHandler)}>
                                {DynamicInputSelect({
                                    register,
                                    errors,
                                    label: 'User',
                                    name: 'user',
                                    value: 'name',
                                    data:
                                        dataUsers &&
                                        dataUsers.data,
                                    placeholder: 'User',
                                })}
                                <AddSpacesToUser
                                    register={register}
                                    label={'spaces'}
                                    name={"spaces"}
                                    errors={errors}
                                    watch={watch}
                                    dataSpaces={dataSpaces}
                                    setValue={setValue}
                                    selectedSpaces={selectedSpaces}
                                    setSelectedSpaces={setSelectedSpaces}
                                />
                                <div className='modal-footer'>
                                    <button
                                        type='button'
                                        className='btn btn-secondary '
                                        data-bs-dismiss='modal'
                                        onClick={formCleanHandler}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type='submit'
                                        className='btn btn-primary '
                                        disabled={isLoadingPost || isLoadingUpdate}
                                    >
                                        {isLoadingPost || isLoadingUpdate ? (
                                            <span className='spinner-border spinner-border-sm'/>) : ('Submit')}
                                    </button>
                                </div>
                            </form>)}
                    </div>
                </div>
            </div>
        </div>)
}

export default FormUserSpaces
